import { createSelector } from 'reselect';
import { getProjectListState } from 'src/modules/project-list/selectors/getProjectListState';

export const getProjectListImport = createSelector([
  getProjectListState,
], (state) => state.import);
